export const useGetParams = () => {
  const searchParams = new URL(document.location).searchParams;
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  return {
    demo: searchParams.get('demo') || false,
    carousel: searchParams.get('carousel') || '0',
    user: searchParams.get('user') || '1015657133',
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 10000,
    period: searchParams.get('period')
      ? parseInt(searchParams.get('period') || '')
      : 600,
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 10,
    startFrom: parseInt(searchParams.get('startFrom') || '') || 1,
    bg: searchParams.get('bg') || "1",

    title: searchParams.get('title'),
    socials: searchParams.get('socials'),
    phoneNumber,

    minFontWords: searchParams.get('minFontWords') || 35,
    maxFontWords: searchParams.get('maxFontWords') || 65,

    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    qrTitle1: searchParams.get('qrTitle1'),
    qrTitle2: searchParams.get('qrTitle2'),
  };
};
